import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllServices } from "../../api/apiServices";
import parseError from "../../utils/parseError";

const useForceDeleteAllServices = () => {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteAllSer,
        isPending: isForceDeleteAll,
    } = useMutation({
        mutationFn: forceDeleteAllServices,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["services"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete services");
        },
    });

    return {
        forceDeleteAllSer,
        isForceDeleteAll,
    };
};

export default useForceDeleteAllServices;
